// @flow
import type {Node} from 'react';
import type {ViewProps} from 'bfu-auth-client/src/login/types/Types.js';

import React from 'react';

import Box from 'react-goose/lib/position/Box';
import Button from 'react-goose/lib/Button';
import Link from 'react-goose/lib/Link';

import useParcelForm from 'react-dataparcels/useParcelForm';
import validation from 'react-dataparcels/validation';

import Loader from 'bfu-auth-client/src/affordance/Loader.jsx';
import BlueflagAuth from 'bfu-auth-client/src/login/data/BlueflagAuth.js';
import StatusMessage from 'bfu-auth-client/src/login/appliance/StatusMessage.jsx';
import createStatusFromParcel from 'bfu-auth-client/src/login/data/createStatusFromParcel.js';

import {verificationCodeValidator} from 'bfu-auth-client/src/login/data/Validators.js';
import {VerificationCodeField} from 'bfu-auth-client/src/login/appliance/Fields.jsx';

const SignupConfirmView =  (props: ViewProps): Node => {
    let {config, next, context, links, status} = props;
    let SigninLink = links.signin;
    let {username} = context;

    let resend = () => next('SIGNUP_CONFIRM_RESEND', {username});

    let [signupConfirmParcel, signupConfirmControl] = useParcelForm({
        value: () => ({
            verificationCode: ''
        }),
        onChange: async (parcel) => {
            let {verificationCode} = parcel.value;
            return BlueflagAuth()
                .signUpConfirm(username, verificationCode)
                .then(() => next('SIGNUP_CONFIRM_SUCCESS'));
        },
        validation: () => validation({
            'verificationCode': verificationCodeValidator
        })
    });

    if(signupConfirmControl.onChangeStatus.isPending) {
        return <Loader modifier="sizeMega center" text={config.signupConfirm.loadingText} />;
    }

    let submit = (e) => {
        e.preventDefault();
        signupConfirmControl.submit();
    };

    status = createStatusFromParcel(signupConfirmControl, status);

    // description
    let {verificationValue} = context.verificationResponse || {};
    let verificationString = verificationValue ? ` (${verificationValue})` : ``;
    let description = config.signupConfirm.description
        .replace('<verificationValue>', verificationString);

    return <div className="BlueflagAuthForm">
        {config.signupConfirm.title &&
            <h1 className="BlueflagAuthFormText BlueflagAuthFormText-sizeGiga BlueflagAuthFormText-marginGiga">{config.signupConfirm.title}</h1>
        }
        {description &&
            <p className="BlueflagAuthFormText">{description}</p>
        }
        <StatusMessage status={status} />
        <form onSubmit={submit} method="post">
            <VerificationCodeField
                parcel={signupConfirmParcel.get('verificationCode')}
                fieldsConfig={config.fields}
            />
            <Box spruceName="BlueflagAuthFormButtonContainer">
                <Button spruceName="BlueflagAuthFormButton" modifier="primary" type="submit">{config.signupConfirm.submitButton}</Button>
                <Link spruceName="BlueflagAuthFormLink" onClick={resend}>{config.signupConfirm.resendLink}</Link>
                <SigninLink>{config.signupConfirm.backLink}</SigninLink>
            </Box>
        </form>
    </div>;
};

export default SignupConfirmView;